import { RootState } from "../store";
export const selectRefreshTokenPlans = (state: RootState) => state.plans.refreshToken;
export const selectPlans = (state: RootState) => state.plans.plans;
export const selectSelectedPlan = (state: RootState) => state.plans.selectedPlan;
export const selectErrorMessagePlans = (state: RootState) => state.plans.errorMessage;
export const selectBienAsegurados = (state: RootState) => state.plans.bienAsegurado;
export const selectSaleStatus = (state: RootState) => state.plans.saleStatus;
export const selectEmmision = (state: RootState) => state.plans.emmision;